/**
 * SoundType.js
 * Maps easy-to-use sound variables to the IDs that were given to each sound file in assets.json
 * 
 * Created on 15-oct-2013
 * 
 * @author Olivier van der Pool for Ranj
 * 
 **/

const SoundType = {
    BUTTON_CLICK: "ui_button_select_generic",
    CHARACTER_HOVER: "ui_hud_character_highlight",
    COACH_SHOW: "ui_hud_robby_show",
    COACH_HIDE: "ui_hud_robby_hide",
    COACH_CHAT_BOX: "ui_hud_robby_chatbox_popUp",
    COACH_CHAT_PANEL_SHOW: "ui_hud_chat_robby_show",
    COACH_CHAT_PANEL_HIDE: "ui_hud_chat_robby_hide",
    COACH_BUTTON_NUDGE: "ui_hud_robby_warning_start",
    COACH_BUTTON_NUDGE_REPEAT: "ui_hud_robby_warning_followup",
    PLAYER_INPUT_PANEL_APPEARS: "ui_hud_inputWindow_appear",
    BRACKET_BUTTON_CLICK: "ui_button_select_robby",
    BRACKET_BUTTON_HOVER: "ui_button_hoverOver_robby",
    TRACKER_BAR_INCREASE: "ui_hud_bar_stats_increase_positive",
    TRACKER_BAR_DECREASE: "ui_hud_bar_stats_increase_negative",
    TRACKER_INCREASE: "ui_hud_trustGained",
    TRACKER_DECREASE: "ui_hud_trustLost",
    TRANSITION_TO_NEW_SCENARIO: "ui_transition_scenario",
    TYPEWRITER_COACH: "ui_hud_talking_generic", // NOTE: Changed coach typewriter to generic typewriter sound on purpose.
    TYPEWRITER_GENERIC: "ui_hud_talking_generic",
    END_OF_GAME_TRANSITION: "stinger_scoreScreen",
    END_OF_GAME_COACH: "ui_hud_endscreen_robby",
    END_OF_GAME_METER_FILLING: "ui_hud_endscreen_scoreCounter",
    END_OF_GAME_METER_SHOW: "ui_hud_scoreScreen_meter_show",
    END_OF_GAME_METER_HIDE: "ui_hud_scoreScreen_meter_hide",
    END_OF_GAME_CONFETTI: "ui_hud_scoreScreen_confetti",
};

export default SoundType;